export const DEFAULT_MAX_RANGE = 6
export const DEFAULT_WARNING_RANGE = 3
